import React from "react";
import ReactDOM from "react-dom";

import Modal from "shared/components/Modal";
import PhoneVerification from "apps/phone_verification/App";

const PhoneVerificationModal = (props) => (
	<Modal show={true} onCancel={PhoneVerificationModal.close}>
		<PhoneVerification {...props} />
	</Modal>
);

PhoneVerificationModal.rootElementId = "phone_verification_modal";

PhoneVerificationModal.close = () => {
	const rootEl = document.getElementById(PhoneVerificationModal.rootElementId);

	if (rootEl) {
		requestAnimationFrame(() => {
			ReactDOM.unmountComponentAtNode(rootEl);
		});
	}
};

PhoneVerificationModal.open = (props) => {
	let rootEl = document.getElementById(PhoneVerificationModal.rootElementId);

	if (!rootEl) {
		rootEl = document.createElement("div");
		rootEl.id = PhoneVerificationModal.rootElementId;
		document.body.appendChild(rootEl);
	}

	ReactDOM.render(<PhoneVerificationModal {...props} />, rootEl);
};

export default PhoneVerificationModal;



// WEBPACK FOOTER //
// ./src/shared/components/ModalPhoneVerification.jsx